'use client'
import styles from '../../OnboardingForm.module.scss'
import bgimage from './bgimage.svg'
import bgimageMobile from './bgimage-mobile.svg'
import { useState } from 'react'
import { readStoredData } from '@/src/components/common/OnboardingForm/OnboardingForm.client'
import Img from '@/src/components/common/Img/Img'
import CheckboxGroup from '@/src/components/common/CheckboxGroup'

export default function SwitchProviderMoreDetailsForm() {
  const [onboardingData] = useState(readStoredData())
  const name = 'more_details__switch_provider__reasons'

  return (
    <>
      <div>
        <div>
          <h3 className={styles.heading}>{`What’s prompting you to switch providers?`}</h3>
          {`You can select more than one option`}
        </div>
        <CheckboxGroup
          required={1}
          options={[
            'I’m unhappy with the quality of care',
            'I want more flexibility or choice',
            'I’m looking for better value or pricing',
            'I’ve moved to a new area',
            'None of the above',
            'I’m not sure / I prefer not to say',
          ]}
          name={name}
          values={(onboardingData.data?.[name] || []) as string[]}
          className={styles.plainOptions}
        />
      </div>
      <div>
        <Img src={bgimage.src} className={styles.desktop} />
        <Img src={bgimageMobile.src} className={styles.mobile} />
      </div>
    </>
  )
}
